<template>
  <div class="employee-page" v-loading.fullscreen.lock="fullscreenLoading">
    <el-card class="header-content">
      <div class="title" v-if="isOK">浙江易尤特科技股份有限公司</div>
      <div class="card-header" :class="isOK ? 'isSuccess' : 'isError'">
        <div class="succeed">{{ isOK ? '认证成功' : '认证失败'}}</div>
      </div>
      <div class="time">认定时间：{{curTime}}</div>
    </el-card>
    <el-card class="employee-card">
      <div class="card-content" v-if="isOK">
        <div class="card-item">
          <div class="item">
            <div class="text detp">{{userData.department}}</div>
            <div class="text job">{{userData.title}}</div>
            <div class="text name">{{userData.name}}</div>
          </div>
          <div class="item">
            <el-image
              style="width: 100px; height: 100px;border-radius: 5px;"
              :src="userData.avatar" fit="cover">
            </el-image>
          </div>
        </div>
        <div class="card-desc">
          <div>管辖范围：{{ userData.region || '-' }}</div>
          <div>当前定位：{{ address || '-'}}</div>
        </div>
      </div>
      <div v-if="!isOK">
        <div class="error-text" style="padding-bottom: 10px">{{hintText}}</div>
        <div style="color: #666;text-align: left;">当前定位：{{ address || '-'}}</div>
      </div>
    </el-card>
    <el-card class="evaluate-card" v-if="isOK && evaluateState">
      <el-form class="evaluate-form" ref="evaluateForm" :model="evaluateForm" :rules="evaluateFormRules">
        <el-form-item label="评价" prop="score">
          <div>
            <el-rate :max="5" :texts="['极差', '差', '一般', '满意', '非常满意']" v-model="evaluateForm.score" show-text @change="handleChangeStar"></el-rate>
          </div>
        </el-form-item>
        <el-form-item label="" prop="content">
          <el-input type="textarea" :rows="4" show-word-limit :maxlength="200" v-model="evaluateForm.content" placeholder="请输入评价内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 100%;" type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { recordConfirm, getUserInfo, putFeedback } from '@/api/index.js'
import dayjs from 'dayjs'
export default {
  name: 'employee',
  data() {
    var checkScore = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('评价星级必填！'));
      }
      setTimeout(() => {
        callback();
      }, 1000);
    };
    return {
      fullscreenLoading: false,
      userId: '',
      hintText:'',
      userData: {
        name: '',
        department: '',
        title: '',
        avatar: require('@/assets/avatvr.png'),
        region: '',
      },
      isOK: false,
      evaluateState:true,
      curTime:'',
      address:'',
      evaluateForm: {
        score: null,
        content: '',
        id:''
      },
      evaluateFormRules: {
        score: [
          { required: true, validator: checkScore,message: '请选择星级', trigger: 'change' }
        ],
      }
    }
  },
  created() {
    let params = this.$route.query
    this.address = params.address
    if (params.text) { 
      this.checkrConfirm(params.text)
    }
    if (params.id) { 
      this.getUserData(params.id)
    }
  },
  methods: {
    async checkrConfirm(text) { 
      let res = await recordConfirm(text)
      if (res.code == '200') {
        this.curTime = res.result.confirmTime
        this.evaluateForm.id = res.result.id
        if (res.result) {
          this.isOK = true
        } else {
          this.isOK = false
        }
      } else { 
        
        this.curTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
      this.hintText = res.msg
    },
    async getUserData(userId) { 
      this.fullscreenLoading = true
      let res = await getUserInfo(userId)
      if (res.code == '200') { 
        let d = res.result
        this.userData = {
          name: d.name,
          department: d.department,
          title: d.title,
          region: d.region,
        }
        if (d.avatar.length == 0) {
          this.userData.avatar = require('../../assets/avatvr.png')
        } else { 
          this.userData.avatar = d.avatar
        }
        this.fullscreenLoading = false
      }
    },
    handleChangeStar(v) {
      this.evaluateForm.score = v
    },
    onSubmit() { 
      this.$refs.evaluateForm.validate(async (valid) => {
        if (valid) {
          let res = await putFeedback(this.evaluateForm)
          if (res.code == '200') { 
            this.$message.success('评价提交成功')
            this.evaluateState = false
            this.evaluateForm = {
              score: null,
              content: '',
              id:''
            }
          }
        }
      });
    }
  }
}
</script>
<style scoped>
.employee-page{
  height: 100vh;
  box-sizing: border-box;
  padding: 20px 18px;
}
.header-content {
  margin-bottom: 20px;
  font-size: 13px;
}
.header-content .title {
  text-align: left;
  font-weight: bold;
  font-size: 16px;
  padding-left: 42px;
  height: 30px;
  background: url("../../assets/small_logo.png") no-repeat;
  background-size: 40px;
  background-position: 0 0;
}
.header-content .time {
  color: #777;
}
.employee-card {
  padding: 0;
  position: relative;
  margin-bottom: 20px;
}
/deep/ .el-card__body {
  padding: 20px 15px;
}
.card-header {
  margin: 30px auto;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  border-radius: 50%;
}
.isSuccess {
  color: #41a012;
  border: 3px solid #41a012;
}
.isError{
  margin: 20px auto;
  color: #f56c6c;
  border: 3px solid #f56c6c;
}
.card-header div{
  font-size: 18px;
}
.card-header .succeed {
  font-weight: bold;
}
.card-header .time{
  padding-top: 0;
  font-size: 13px;
}
.error-text {
  color: #f56c6c;
}
.error-text .time {
  color: #777;
  padding-top:10px;
}
.card-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.card-item .text{
  text-align: left;
  padding-bottom: 10px;
}
.card-item .detp,
.card-item .job{
  color: #777;
  font-size: 15px;
}
.card-item .name {
  font-size: 26px;
  font-weight: bold;
}
.card-desc {
  text-align: left;
}
.card-desc div{
  color: #777;
  font-size: 15px;
  padding-bottom: 8px;
}
.evaluate-form /deep/ .el-form-item__label {
  float: none;
}
.evaluate-form /deep/ .el-rate {
  height: 30px;
}
.evaluate-form /deep/ .el-rate__icon{
  font-size: 28px;
}

</style>